export async function studyDownload(
  token: string,
  studyInstanceUID: string,
  studyDescription: string,
  studyDate: string
) {
  try {
    const { downloadStudyURL } = (window as any).data.download;
    const safeStudyDate = studyDate.replace(/\s+/g, '_');
    const safeStudyDescription = studyDescription.replace(/\s+/g, '_');
    const filename = `${safeStudyDate}-${safeStudyDescription}.zip`;
    const response = await fetch(downloadStudyURL, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify({
        StudyInstanceUID: studyInstanceUID,
        filename: filename,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to trigger download: ${response.statusText}`);
    }
    const data = await response.json();
    const link = document.createElement('a');
    link.href = data.download_url;
    link.download = data.filename || 'dicom_study.zip';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error in triggerDownload:', error);
    throw error;
  }
}